import React, { useState } from 'react';
import { Menu, MenuItem } from '../Menu';
import { composePlaceholders, placeholderWord } from '../../domain/compose';
import c from './composer.module.css';

// New Message's placeholder menu (#604), MMS's: a button titled
// "Placeholder" beside the toolbar's, whose twelve entries — Account Balance
// to Today's Date, MMS's order and words — each write MMS's token
// (`%FirstName%`) as text at the cursor, in place of any selection. The
// message holds the token; the sender fills it for each recipient
// (functions/delivery/placeholders.js). core/src/placeholders.rs says what of
// MMS's each keeps.
//
// `onPick(key)` is the message editor's (MessageBodyEditor.jsx): it writes
// the token over the box's selection, which the box keeps while the menu is
// open — neither the trigger nor an entry takes the focus — and puts the
// cursor back in the box after the token.
//
// `placeholders` is the menu's entries, New Message's twelve by default; the
// Send Invoice drawer (#622) hands in its own (`invoiceEmailPlaceholders`).
export default function MessagePlaceholderMenu({ onPick, placeholders = null }) {
  const [open, setOpen] = useState(false);
  const label = placeholderWord('menu');
  return (
    <Menu
      open={open}
      onClose={() => setOpen(false)}
      align="left"
      trigger={(
        <button
          type="button"
          className={c.tool}
          title={`${label}: ${placeholderWord('menu_hint')}`}
          aria-haspopup="menu"
          aria-expanded={open}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => setOpen((o) => !o)}
        >
          {label} ▾
        </button>
      )}
    >
      {(placeholders || composePlaceholders()).map((p) => (
        <MenuItem
          key={p.key}
          // The box keeps the focus while an entry is pressed, as it does
          // for the trigger: an entry that took it would leave it on the page
          // once the menu closed (MessageBodyEditor.jsx).
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => { setOpen(false); onPick(p.key); }}
        >
          {p.label}
        </MenuItem>
      ))}
    </Menu>
  );
}
